import { useState, useEffect } from "react";
import api from "../services/api";
import { useNavigate, useParams } from "react-router-dom";
import variablesConexionBack from "../variablesConexionBack/variablesConexionBack.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faSquareCaretLeft } from "@fortawesome/free-solid-svg-icons";
const EditPersona = ({ persona, onClose, onEditSuccess }) => {
  const [Nombre, setNombre] = useState("");
  const [Email, setEmail] = useState("");
  const [Apellido, setApellido] = useState("");
  const [Edad, setEdad] = useState("");
  const [Sexo, setSexo] = useState("");
  const [IdTipoDocumento, setIdTipoDocumento] = useState("");
  const [IdTipoEstadoPersona, setIdTipoEstadoPersona] = useState("");
  const [IdPais, setIdPais] = useState("");
  const [NroDocumento, setNroDocumento] = useState("");
  const [NombrePais, setNombrePais] = useState([]);
  const [TipoDocumento, setTipoDocumento] = useState([]);
  const [TipoEstadoPersona, setTipoEstadoPersona] = useState([]);

const documentoActual = TipoDocumento.find(
  (doc) => Number(doc.idTipoDocumento) === Number(IdTipoDocumento)
);

  // Cargar países y estados al montar
  useEffect(() => {
    fetchPaises();
    fetchTipoEstadosPersona();
  }, []);

  // Setear datos iniciales desde la persona
  useEffect(() => {
    if (persona) {
       console.log("Datos del usuario seleccionado:", persona);
 
      setEmail(persona.Email || "");
      setNombre(persona.Nombre || "");
      setApellido(persona.Apellido || "");
      setEdad(persona.Edad || "");
      setSexo(persona.Sexo || "");
      setIdPais(persona.IdPais || "");
      setIdTipoEstadoPersona(persona.IdTipoEstadoPersona || "");
      setNroDocumento(persona.NroDocumento || "");
     setIdTipoDocumento(persona.IdTipoDocumento || ""); // <-- AGREGA ESTA LÍNEA
   
      console.log("Datos del despues usuario seleccionado:", persona);
 
    }
  }, [persona]);

  // Cargar tipos de documento cuando cambia el país
  useEffect(() => {
    if (IdPais) {
      fetchTipoDocumentosPorPaises(IdPais);
    } else {
    //  setTipoDocumento([]);
    //  setIdTipoDocumento("");
    }
  }, [IdPais]);

  // Setear tipo documento si existe en la lista
  useEffect(() => {
    if (
      persona &&
      TipoDocumento.length > 0 &&
      persona.IdTipoDocumento !== undefined &&
      persona.IdTipoDocumento !== null
    ) {
      const existe = TipoDocumento.some(
        (doc) => doc.IdTipoDocumento === persona.IdTipoDocumento
      );
      if (existe) {
        setIdTipoDocumento(persona.IdTipoDocumento);
      } else {
        console.warn("Tipo de documento no encontrado en lista");
      }
    }
  }, [TipoDocumento, persona]);

  const fetchPaises = async () => {
    try {
      const response = await api.get(`${variablesConexionBack.linkBackend}/paises`);
      const paisesActivos = response.data.filter((pais) => pais.estado === 1);
      setNombrePais(paisesActivos);
    } catch (error) {
      console.error("Error al obtener los países:", error);
    }
  };

  const fetchTipoDocumentosPorPaises = async (paisId) => {
    try {
      const response = await api.get(`${variablesConexionBack.linkBackend}/tipodocumentos/${paisId}`);
      setTipoDocumento(response.data);
    } catch (error) {
      console.error("Error al obtener los tipos de documentos:", error);
      setTipoDocumento([]);
    }
  };

  const fetchTipoEstadosPersona = async () => {
    try {
      const response = await api.get(`${variablesConexionBack.linkBackend}/estados`);
      setTipoEstadoPersona(response.data);
    } catch (error) {
      console.error("Error al obtener los estados de persona:", error);
    }
  };
 
  const updatePersona = async (e) => {
    e.preventDefault();
    try {
      await api.patch(`${variablesConexionBack.linkBackend}/personas/${persona.IdPersona}`, { Email, Nombre, Apellido, Edad, Sexo, IdTipoDocumento, IdTipoEstadoPersona, IdPais, NroDocumento });
      onEditSuccess();
      onClose();
    } catch (error) {
      console.error("Error al actualizar la persona:", error);
    }
   };
   console.log("Tipos de documentos disponibles:", TipoDocumento);
console.log("IdTipoDocumento:", IdTipoDocumento, typeof IdTipoDocumento);
console.log("TipoDocumento:", TipoDocumento);
  return (
    <form onSubmit={updatePersona} className="form-grid">
      <div className="field">
        <label className="label">Nacionalidad</label>
        <select
          className="input"
          value={IdPais}
          onChange={(e) => setIdPais(e.target.value)}
          required
        >
          <option value="">Seleccionar</option>
          {NombrePais.map((pais) => (
            <option key={pais.IdPais} value={pais.IdPais}>
              {pais.Nombre}
            </option>
          ))}
        </select>
      </div>

      <div className="field">
        <label className="label">Nombre</label>
        <input
          className="input"
          type="text"
          value={Nombre}
          onChange={(e) => setNombre(e.target.value)}
          required
        />
      </div>

      <div className="field">
  <label className="label">Tipo de Documento</label>

  
  <select
    className="input"
    value={IdTipoDocumento}
    onChange={(e) => setIdTipoDocumento(e.target.value)}
    required
  >
    <option value="">Seleccionar</option>
    {/* Si el documento actual no está en la lista, lo mostramos como opción especial */}
    {!TipoDocumento.some(doc => doc.idTipoDocumento === Number(IdTipoDocumento)) && IdTipoDocumento && (
      <option value={IdTipoDocumento}>
        Documento actual ( {documentoActual ? documentoActual.TipoDocumento : "Desconocido"} )
      </option>
    )}

    {TipoDocumento.map((doc) => (
      <option key={doc.idTipoDocumento} value={doc.idTipoDocumento}>
        {doc.TipoDocumento}
      </option>
    ))}
  </select>
</div>


      <div className="field">
        <label className="label">Apellido</label>
        <input
          className="input"
          type="text"
          value={Apellido}
          onChange={(e) => setApellido(e.target.value)}
          required
        />
      </div>

      <div className="field">
        <label className="label">Número de Documento</label>
        <input
          className="input"
          type="number"
          value={NroDocumento}
          onChange={(e) => setNroDocumento(e.target.value)}
          required
        />
      </div>

      <div className="field">
        <label className="label">Edad</label>
        <input
          className="input"
          type="number"
          value={Edad}
          onChange={(e) => setEdad(e.target.value)}
          required
        />
      </div>

      <div className="field">
        <label className="label">Email</label>
        <input
          className="input"
          type="email"
          value={Email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </div>

      <div className="field">
        <label className="label">Sexo</label>
        <select
          className="input"
          value={Sexo}
          onChange={(e) => setSexo(e.target.value)}
          required
        >
          <option value="">Seleccionar</option>
          <option value="Masculino">Masculino</option>
          <option value="Femenino">Femenino</option>
        </select>
      </div>

      <div className="field buttons">
        <button type="submit" className="button is-primary" id="Guardar">
          Guardar <FontAwesomeIcon icon={faCheck} />
        </button>
      </div>
    </form>
  );
};

export default EditPersona;